import normalize from "json-api-normalizer";

import BaseService from "./BaseService";

export default {
  load() {
    return BaseService.get("providers").then(
      response => normalize(response.data).users
    );
  }
};
